import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2025M10() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2025-10-01.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Amanda Viana
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    23-26 October 2025, Labyrinth (Zagarolo, Rome – Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Workshop: <i>Modes of Socialization with Non-Human Agency</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                    <b>Project Animism in Practice</b>
                  </Blockquote>
                  <Blockquote size="2" color>
                    Interstices Center in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    The present workshop focuses on modes of socialization inspired by non-Western societies, especially concerning ritual and transformation. It intends to emphasize the deep psychological, anthropological, and ontological meaning of “non-human agency” as a living factor of relationship. A serious consideration of that type of agency demands a special approach to “cultural difference”, in which a common ground between notions like psychic field and the cultural horizon can be found and nurtured according to the challenges of our time.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
